import { forwardRef, useRef } from 'react';

import { mergeRefs } from '../../../utils/react';

/**
 * Unstyled/headless primitive for accessible input button
 * (similar to radix primitives)
 *
 * can be used as a building block for your styled component
 */
const InputButtonPrimitive = forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>((props, forwardedRef) => {
  const ref = useRef<HTMLInputElement>(null);

  const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.stopPropagation();
      e.preventDefault();
      ref.current?.click();
    }
  };

  return (
    <input
      type="button"
      onKeyDown={handleKeyDown}
      {...props}
      ref={mergeRefs(ref, forwardedRef)}
    />
  );
});

InputButtonPrimitive.displayName = 'InputButtonPrimitive';

export default InputButtonPrimitive;
